import { styled } from '@mui/material/styles';
import { globalZindex } from 'core/common/constants';
import Icon from 'core/svg-sprites/ui/Icon';

export const SupportBotWrapperStyled = styled('div')<{ variant: 'static' | 'fixed' }>`
  position: ${({ variant }) => (variant === 'fixed' ? 'fixed' : 'static')};
  right: 16px;
  bottom: 5px;
  z-index: ${globalZindex.banner};
`;

export const IconStyled = styled(Icon)`
  margin-right: 4px;
  fill: currentColor;
`;
